import { createStore } from 'vuex'
import {authStore} from './modules/users/store'

export default createStore({
    modules: {
        authStore
    },
})